angular.module('wbServices').service 'homeBuyingPlan', ['finance', 'tax', (finance, tax) ->
  @calculatePlanData = (plan) ->
    realMonthlyRate = finance.realRateOfReturn(plan.interestRate, plan.inflationRate) / 12
    month = 0
    savings = plan.existingSavings + plan.existingTFSASavings
    savingsPlan = []
    while savings <= (plan.percentDownPayment + plan.percentClosingCosts) * plan.desiredHousePrice
      month++
      savings = plan.monthlySavings + savings * (1 + realMonthlyRate)
      savingsPlan.push
        month: month
        year: month/12
        savings: savings

    plan: savingsPlan
    totalSavings: savings
    years: Math.floor(month / 12)
    months: month % 12
  @
]
